import $ from 'jquery';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class ContentSlider {
    constructor() {
        if($('.js-content-slider').length) {
            const contentSlider = new Swiper('.js-content-slider', {
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 3
                    }
                },
                navigation: {
                    nextEl: '.js-content-slider__next',
                    prevEl: '.js-content-slider__prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar'
                },
                slidesPerView: 1,
                spaceBetween: 20,
                watchOverflow: true
            });
        };
    }
}
